import { Box } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { Device, FShift, UserCompact } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import Spinner from "../../../../ui/Spinner/Spinner";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../../ui/Tabs/Tabs";
import DeviceSettingsTab from "./tabs/DeviceSettingsTab";

const AdminDeviceItem = () => {
  const { id } = useParams();

  const [{ response, isLoading, error }, doFetchCurrentItem] = useFetch(
    `/administration/devices/devices/${id}`,
    true,
  );

  const [loading, setLoading] = useState(true);
  const [currentDevice, setCurrentDevice] = useState<Device>();

  useEffect(() => {
    if (!id) {
      return;
    }
    setLoading(true);
    doFetchCurrentItem();
  }, [id]);

  useEffect(() => {
    if (!response) {
      return;
    }
    const responseData = response.data as unknown as Device;
    setCurrentDevice(responseData);
    setLoading(false);
  }, [response]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <Tabs defaultValue="settings" className="w-full h-full">
        <TabsList className="flex-none flex w-full h-12 bg-background">
          <div className="flex w-full max-w-[900px] justify-start mx-auto pl-4 pr-16">
            {/* <Tabs.Trigger className="data-[state=active]:bg-muted data-[state=active]:text-foreground" value="main">{t("main_info")}</Tabs.Trigger> */}
            <TabsTrigger
              className="data-[state=active]:bg-muted data-[state=active]:text-foreground"
              value="settings"
            >
              {t("settings")}
            </TabsTrigger>
          </div>
        </TabsList>
        <Separator />
        <ScrollArea>
          <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden mb-20">
            <TabsContent value="settings">
              <DeviceSettingsTab id={id} currentDevice={currentDevice} />
            </TabsContent>
          </div>
        </ScrollArea>
      </Tabs>
    </>
  );
};

export default AdminDeviceItem;
